import React, { useState, useRef } from 'react';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { rankWith, scopeEndsWith } from '@jsonforms/core';
import { Button, Stack, Box, Fab } from '@mui/material';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import DeleteIcon from '@mui/icons-material/Delete';

import { useResponsive } from '../../../services/hooks';


function ImageField(props) {
  const { id, label, handleChange, path } = props;
  const ref = useRef(null);
  const [preview, setPreview] = useState(null);
  const isDesktop = useResponsive('up', 'lg');

  const deleteImage = () => {
    setPreview(null);
    handleChange(path, undefined);
    if (ref.current !== null) {
      ref.current.value = null;
    }
  };

  const handleChangeImage = e => {
    const image = e.target.files[0];
    if (['image/jpg', 'image/jpeg', 'image/png'].includes(image.type)) {
      handleChange(path, e.target.files[0]);
      const r = new FileReader();
      r.onload = e => {
        setPreview(e.target.result);
      };
      r.readAsDataURL(image);
    } else {
      deleteImage();
    }
  };

  return (
    <Stack flexDirection={isDesktop ? 'row' : 'column'} alignItems="center">
      <Button variant="contained" component="label" sx={ isDesktop ? { mr: 4 } : { mb: 4 }} endIcon={<AddAPhotoIcon />}>
        {label}
        <input id={id} type="file" accept="image/*" hidden ref={ref} onChange={handleChangeImage}/>
      </Button>
      {preview !== null
        ? <Box style={{ position: 'relative' }}>
          <img
            src={preview}
            alt="przesłane zdjęcie"
            width={200}
            height={300}
            style={{ borderRadius: '8px', objectFit: 'cover', border: '2px solid #00AB55' }}/>
          <Fab size="small" color="error" style={{ position: 'absolute', top: '-12px', right: '-12px' }} onClick={deleteImage}>
            <DeleteIcon />
          </Fab>
        </Box>
        : null}
    </Stack>
  );
}

export default withJsonFormsControlProps(ImageField);


export const ImageFieldTester = rankWith(1000, scopeEndsWith('_image'));
